// eslint-disable-next-line no-restricted-syntax
export enum ExpiryType {
  DOES_NOT_EXPIRE = "Does not expire",
  EXPIRY_DATE = "Expiry Date",
  ISSUE_PLUS_VALIDITY = "Issue Date + Validity",
}

// eslint-disable-next-line no-restricted-syntax
export enum RequirementWorkflowType {
  PERSONAL_ID_STRIPE_VERIFICATION = "PERSONAL_ID_STRIPE_VERIFICATION",
  CHECKR_BACKGROUND_CHECK = "CHECKR_BACKGROUND_CHECK",
  PROFESSIONAL_REFERENCES = "PROFESSIONAL_REFERENCES",
  DOCUMENT_UPLOAD = "DOCUMENT_UPLOAD",
  SIGN_WITH_HELLOSIGN = "SIGN_WITH_HELLOSIGN",
  COMPOSITE = "COMPOSITE",
  MISCELLANEOUS = "MISCELLANEOUS",
  BLS_CPR_CERTIFICATION_QUIZ = "BLS_CPR_CERTIFICATION_QUIZ",
  TB_TEST_WITH_APPOINTMENT = "TB_TEST_WITH_APPOINTMENT",
  TB_TEST_GUIDED_UPLOAD = "TB_TEST_GUIDED_UPLOAD",
  TEN99_POLICY_COVERAGE = "TEN99_POLICY_COVERAGE",
}

export const REQUIREMENT_RESOURCE = "requirements";

export const WORKPLACE_VISIBILITY = {
  NOT_VISIBLE: "NOT_VISIBLE",
  VISIBLE_TO_ALL: "VISIBLE_TO_ALL",
  VISIBLE_TO_MAPPED_ONLY: "VISIBLE_TO_MAPPED_ONLY",
} as const;
export type WorkplaceVisibility = (typeof WORKPLACE_VISIBILITY)[keyof typeof WORKPLACE_VISIBILITY];

export const REQUIREMENT_INCLUDE_RESOURCE = {
  prerequisiteActions: "prerequisiteActions",
} as const;

export type RequirementIncludeResource =
  (typeof REQUIREMENT_INCLUDE_RESOURCE)[keyof typeof REQUIREMENT_INCLUDE_RESOURCE];

export const MAPPINGS_MANAGED_BY = {
  ELIGIBILITY_ENGINE: "ELIGIBILITY_ENGINE",
} as const;

export type MappingsManagedBy = (typeof MAPPINGS_MANAGED_BY)[keyof typeof MAPPINGS_MANAGED_BY];

export const MAPPINGS_MANAGED_BY_FILTER = {
  ...MAPPINGS_MANAGED_BY,
  UNLOCKED: "UNLOCKED",
} as const;

export type MappingsManagedByFilter =
  (typeof MAPPINGS_MANAGED_BY_FILTER)[keyof typeof MAPPINGS_MANAGED_BY_FILTER];
